import Title from '@/components/Title';
import { useTranslation } from 'react-i18next';
import { i18n } from 'next-i18next';
import ClassFeature from './ClassFeature';

const VipClass = () => {
  const { t } = useTranslation('english');
  return (
    <div className="container">
      <div className="mb-[1.5rem] mt-[5rem] flex justify-center lg:mb-[48px] lg:mt-[140px] xl:mb-[60px] xl:mt-[200px]">
        <Title innerHTML theme="english" className="relative hidden lg:inline xl:inline xl:tracking-[0.96px]">
          {`${t('vip精英小班-标题', { tag: '' })}
          <div class="absolute right-[-100px] top-[-45px] hidden h-[80px] w-[80px] shrink-0 items-center justify-center rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)] rotate-[-15deg] lg:flex xl:flex">
          <img class="w-[49px]" src="/images/english/thumb.png" alt="" />
        </div>`}
        </Title>
        <Title innerHTML theme="english" className="relative lg:hidden xl:hidden xl:tracking-[0.96px]">
          {t('vip精英小班-标题', { tag: '' })}
        </Title>
      </div>
      {/* mobile */}
      <section>
        <ClassFeature
          imgUrl="/images/english/vip/vip1.png"
          btnName={t('了解更多')}
          title={t('特色1-标题')}
          subTitle={t('特色1-描述')}
          ga="O_EnglishCourse_VIPClassroom_GlobalCoverageCTAClick"
          ga4="new_entry_VIPClassroom_GlobalCoverageCTA"
        />
        <ClassFeature
          imgUrl="/images/english/vip/vip3.png"
          btnName={t('了解更多')}
          title={t('特色2-标题')}
          subTitle={t('特色2-描述')}
          reverse
          ga="O_EnglishCourse_VIPClassroom_MasterpiecesCTAClick"
          ga4="new_entry_VIPClassroom_MasterpiecesCTA"
        />
        <ClassFeature
          imgUrl="/images/english/vip/vip2.png"
          btnName={t('了解更多')}
          title={t('特色3-标题')}
          subTitle={t('特色3-描述')}
          ga="O_EnglishCourse_VIPClassroom_RoundTableCTAClick"
          ga4="new_entry_VIPClassroom_RoundTableCTA"
        />
        <ClassFeature
          imgUrl={`/images/english/vip/vip4_${i18n?.language}.png`}
          btnName={t('了解更多')}
          linkUrl="https://www.wukongsch.com/blog/zh/cognia-certifies-wukong-education-highest-score-global-number-one-post-22206/"
          title={t('特色4-标题')}
          subTitle={t('特色4-描述')}
          reverse
          ga="O_EnglishCourse_VIPClassroom_CogniaCTAClick"
          ga4="new_entry_VIPClassroom_CogniaCTA"
        />
      </section>
    </div>
  );
};

export default VipClass;
